import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import {
  fulfillmentOptions,
  ALL_FULFILLMENT_METHODS
} from 'bento-ordering/cart/constants/fulfillmentOptions';

import SecondaryCta from 'bento-ordering/base/components/SecondaryCta';
import HelpToolTip from 'bento-ordering/base/components/HelpToolTip';
import TaxesAndFeesHelpText from 'bento-ordering/cart/components/TaxesAndFeesHelpText';

const flexProps = {
  justifyContent: 'space-between',
  display: 'flex'
};

class CartInfo extends React.Component {
  static propTypes = {
    clearCart: PropTypes.func,
    total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tax: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    serviceFee: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    subtotal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    taxFieldLabel: PropTypes.string,
    taxesAndFees: PropTypes.string,
    deliveryFee: PropTypes.string,
    customFee: PropTypes.string,
    customFeeName: PropTypes.string,
    bundleServiceFeeWithCustomFee: PropTypes.bool,
    bundledServiceAndCustomFees: PropTypes.string,
    fulfillmentMethod: PropTypes.oneOf(ALL_FULFILLMENT_METHODS)
  };

  renderDeliveryFee = () => {
    const { deliveryFee } = this.props;
    let fee = 'Free';
    if (parseFloat(deliveryFee) > 0) {
      fee = `$${deliveryFee}`;
    }

    return (
      <Box mb={1} {...flexProps}>
        <Typography>Delivery</Typography>
        <Typography data-testid="cart-delivery-fee">{fee}</Typography>
      </Box>
    );
  };

  render() {
    const {
      total,
      subtotal,
      clearCart,
      tax,
      serviceFee,
      taxesAndFees,
      taxFieldLabel,
      customFee,
      customFeeName,
      bundleServiceFeeWithCustomFee,
      bundledServiceAndCustomFees,
      fulfillmentMethod
    } = this.props;
    return (
      <Box mt={2} mb={2}>
        <Box mb={1} {...flexProps}>
          <Typography>Subtotal</Typography>
          <Typography data-testid="cart-subtotal">${subtotal}</Typography>
        </Box>
        <Box mb={1} {...flexProps}>
          <Box display="flex" alignItems="center">
            <Typography>{taxFieldLabel}</Typography>
            {taxesAndFees && (
              <HelpToolTip data-testid="taxes-tooltip">
                <TaxesAndFeesHelpText
                  tax={tax}
                  serviceFee={serviceFee}
                  customFee={customFee}
                  customFeeName={customFeeName}
                  bundleServiceFeeWithCustomFee={bundleServiceFeeWithCustomFee}
                  bundledServiceAndCustomFees={bundledServiceAndCustomFees}
                />
              </HelpToolTip>
            )}
          </Box>
          <Typography data-testid="cart-tax">${taxesAndFees || tax}</Typography>
        </Box>
        {fulfillmentMethod === fulfillmentOptions.DELIVERY &&
          this.renderDeliveryFee()}
        <Box mb={2} {...flexProps}>
          <Typography variant="h4">Total</Typography>
          <Typography variant="h4" data-testid="cart-total">
            ${total}
          </Typography>
        </Box>
        <SecondaryCta
          handleClick={clearCart}
          label="Empty Cart"
          dataTestId="cart-empty-button"
        />
      </Box>
    );
  }
}

export default CartInfo;
